import React, { useState, useRef, useEffect } from 'react';
import { Carousel, Modal } from 'react-bootstrap';
import styles from './VideoCarousel.module.css';
import asu from './Assets/asu.webp';
import max from './Assets/max.webp';
import { FaPlay } from "react-icons/fa6";

interface VideoClip {
  url: string;
  from: number;
  to: number;
  poster: string;
}

const VideoCarousel = () => {
  const [showModal, setShowModal] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState('');
  const videoRefs = useRef<HTMLVideoElement[]>([]);

  const handleVideoClick = (videoUrl: string) => {
    setCurrentVideoUrl(videoUrl);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setCurrentVideoUrl('');
  };

  const videoClips: VideoClip[] = [
    {
      url: "https://d3m0dzbeurmsd7.cloudfront.net/Videos/asu.mp4",
      from: 18,
      to: 25,
      poster: asu
    },
    {
      url: "https://d3m0dzbeurmsd7.cloudfront.net/Videos/BreatheEVV3.mp4",
      from: 19,
      to: 29,
      poster: max
    }
  ];

  const [isPlaying, setIsPlaying] = useState<boolean[]>([]);

  useEffect(() => {
    setIsPlaying(new Array(videoClips.length).fill(false));
  }, []);

  useEffect(() => {
    videoRefs.current.forEach((video, index) => {
      if (!video) return;

      const clip = videoClips[index];
      const { from, to } = clip;

      const onLoaded = () => {
        video.currentTime = from;
        video.play();
      };

      const onTimeUpdate = () => {
        if (video.currentTime >= to) {
          video.currentTime = from;
        }
      };

      const onPlay = () => {
        setIsPlaying((prev) => {
          const updated = [...prev];
          updated[index] = true;
          return updated;
        });
      };

      video.addEventListener('loadedmetadata', onLoaded);
      video.addEventListener('play', onPlay);
      video.addEventListener('timeupdate', onTimeUpdate);

      return () => {
        video.removeEventListener('loadedmetadata', onLoaded);
        video.removeEventListener('play', onPlay);
        video.removeEventListener('timeupdate', onTimeUpdate);
      };
    });
  }, [videoClips]);

  return (
    <div className={styles['video-block']}>
      <Carousel interval={15000} data-bs-theme="dark">
        {videoClips.map((clip, index) => (
          <Carousel.Item key={index} className={styles.videoWrapper}>
            {!isPlaying[index] && (
              <img
                className={styles.posterImage}
                src={clip.poster}
                alt="poster"
              />
            )}
            <video
              ref={(el) => {
                if (el) videoRefs.current[index] = el;
              }}
              src={clip.url}
              muted
              playsInline
              poster={clip.poster}
              autoPlay
              className={styles.loopVideo}
            />
            <button
              onClick={() => handleVideoClick(clip.url)}
              className={styles.playButton}
            >
              <FaPlay />
            </button>
          </Carousel.Item>
        ))}
      </Carousel>

      <Modal show={showModal} onHide={handleClose} size="lg" centered>
        <div style={{ position: 'relative' }}>
          <button onClick={handleClose} className={styles.closeButton}>
            ✕
          </button>
          <Modal.Body style={{ padding: 0 }}>
            <video
              src={currentVideoUrl}
              autoPlay
              controls
              className={styles.modalVideo}
            />
          </Modal.Body>
        </div>
      </Modal>
    </div>
  );
};

export default VideoCarousel;
